import React, { useEffect } from 'react';
import { useTransactionsContext } from '../../contexts/TransactionsContext';
import CopyToClipboard from '../../components/CopyToClipboard';
import { useDefaultContext } from '../../contexts/HomeContext';
import AgeLive from '../../components/TimeLive';
import './Blocks.scss';

interface ITransactionModal {
  data: any;
}

const TransactionDetailsModal: React.FC<ITransactionModal> = ({ data }) => {
  const { getTransactionDetails, transactionDetails } = useTransactionsContext();
  const { chainNetwork } = useDefaultContext();

  useEffect(() => {
    getTransactionDetails(data?.txhash)
  }, [chainNetwork]);

  const handleRedirect = (transactionLink: any) => {
    if (transactionLink) {
      window.open(transactionLink, '_self');
    }
  };

  return (
    <div className="transaction-modal">
      <div className="transaction-content-wrapper">
        <div className="transaction-label">Transaction ID</div>
        <div className="transaction-text link-text">
          <CopyToClipboard text={data?.txhash || '-'} />
        </div>
      </div>
      <div className="transaction-content-wrapper">
        <div className="transaction-label">Payload Proposal Hash</div>
        <div className="transaction-text">{transactionDetails[0]?.payload_proposal_hash || "-"}</div>
      </div>
      <div className="transaction-content-wrapper">
        <div className="transaction-label">Block Number</div>
        <div className="transaction-text">{data?.blockid || data?.blocknum || transactionDetails[0]?.blockid || "-"}</div>
      </div>
      <div className="transaction-content-wrapper">
        <div className="transaction-label">Smart Contract Name</div>
        <div className="transaction-text">{data?.chaincodename || transactionDetails[0]?.chaincodename || "-"}</div>
      </div>
      <div className="transaction-content-wrapper">
        <div className="transaction-label">Status</div>
        <div className={`modal-status ${transactionDetails[0]?.status ? 'success' : 'p-0'}`}>
          {transactionDetails[0]?.status ? 'Success' : '-'}
        </div>
      </div>
      <div className="transaction-content-wrapper">
        <div className="transaction-label">Timestamp</div>
        <div className="transaction-text">
          <div>
            <AgeLive createdAt={transactionDetails[0]?.createdt || '-'} />
            {/*{capitalize(moment(transactionDetails[0]?.createdt).fromNow() || '-' )}*/}
          </div>
        </div>
      </div>
      <div className="transaction-content-wrapper">
        <div className="transaction-label">Direct Link</div>
        <div className="transaction-text">
          {transactionDetails[0]?.directLink ? (
            <CopyToClipboard
              onClick={() => handleRedirect(transactionDetails[0]?.directLink)}
              text={transactionDetails[0]?.directLink || '-'}
              spanStyle='link-style'
            />
          ) : '-'}
        </div>
      </div>
    </div>
  )
}

export default TransactionDetailsModal;
